import { Route, Routes } from 'react-router-dom'
import UserList from '../pages/chat/UserList'
import BlockList from '../pages/chat/BlockList'
import Dashboard from '../pages/Dashboard'
import Login from '../pages/Login'
import { useUserContext } from '../components/contexts/UserContext'
import AppLayout from '../layout'
import GroupList from '../pages/GroupList'
import GroupMember from '../pages/GroupMember'
import Profile from '../pages/Profile'
import PasswordChange from '../pages/PasswordChange'

export function AppRoutes() {
  const { user } = useUserContext()
  return (
    <Routes>

      {user ? (
        <>
          <Route path='/' element={<AppLayout />}>
            {/* <Route path="/" element={<Home />} /> */}
            <Route path="/groupList" element={<GroupList />} />
            <Route path="/groupList/:id/groupMember" element={<GroupMember />} />
            <Route path="/chat/userList" element={<UserList />} />
            <Route path="/chat/blockList" element={<BlockList />} />
            <Route path="/dashboard" element={<Dashboard />} />
            {/* <Route path="/profile" element={<Profile />} /> */}
            <Route path="/profile/info" element={<Profile />} />
            <Route path="/profile/password" element={<PasswordChange />} />
            <Route path="*" element={<Dashboard />} />
          </Route>
        </>
      ) : (
        <>
          <Route path="/login" element={<Login />} />
          <Route path="*" element={<Login />} />
        </>
      )
      }

    </Routes >
  )
}
